import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import withTranslation from 'next-translate/withTranslation'
import { setCurrentGroup, setIsGroupPage } from '../src/modules/groups/actions'
import {
  setCurrentSubCategory,
  setIsCategoryPage,
  fetchCategory,
  setActiveCategories,
  fetchCategories,
  setCategoriesAndGroups
} from '../src/modules/categories/actions'
import { getCurrentSubCategory } from '../src/modules/categories/selectors'
import { getCurrentGroup } from '../src/modules/groups/selectors'
import { TypesHelper, flatten, deepCopy } from '../src/utils'
import { adsTypes, globalOptions } from '../src/core/constants'
import { fetchAds } from '../src/modules/ads/list/actions'
import { setBrands } from '../src/modules/ads/brands/actions'
import { AdsList } from '../src/modules/ads/list/components'
import { PanelMobile } from '../src/modules/ads/list/components/PanelMobile'
import { CategoryPagination } from '../src/modules/ads/pagination/components'
import { AdsHeader } from '../src/modules/ads/filter/components'
import { GroupsMenuMobile } from '../src/modules/categories/components'
import { BottomNavigation } from '../src/modules/layout/BottomNavigation'
import { Page, Page404 } from '../src/ui'
import { setEquipment } from '../src/modules/ads/equipment/actions'
import { fetchProducts, setProducts } from '../src/modules/ads/products/actions'
import { CookiesHelper } from '../src/core/cookiesHelper/CookiesHelper'
import { fetchServices, setServices } from '../src/modules/ads/services/actions'
import { fetchServiceTypes, setServiceTypes } from '../src/modules/ads/serviceTypes/actions'
import { fetchPageMetaTags } from '../src/modules/common/actions'
import initialState from '../src/modules/redux/initialState'
import config from '../src/config/config.json'

class CategoryPage extends React.Component {
  static async getInitialProps ({store, req, query, isServer}) {
    console.log('category page query', query)
    let { category: categoryInUrl, page = 1, locale, ...restQuery } = query

    const isMobileDevice = store.getState().common.isMobileDevice

    const type = adsTypes.all

    const limit = !isMobileDevice ? globalOptions.adsCountPerPage : globalOptions.adsCountPerPageMobile

    const status = 'Published'
    const sortBy = 'dateDesc'

    let formStyle = 'basic'

    let filterValues = {}

    await store.dispatch(setCategoriesAndGroups(categoryInUrl, locale?.toUpperCase()))

    const state = store.getState()

    const currentGroup = getCurrentGroup(state)
    const currentSubcategory = getCurrentSubCategory(state)

    let category, isGroupPage, isCategoryPage
    let adsRequestOptions = restQuery
      ? {...restQuery, page, type, limit, status, sortBy}
      : {page, type, limit, status, sortBy}

    let isPageExists = false

    if (currentSubcategory) {
      category = currentSubcategory
      adsRequestOptions.category = category.id
      isGroupPage = false
      isCategoryPage = true
      isPageExists = true
      await store.dispatch(fetchPageMetaTags({ category: currentSubcategory.id }, locale?.toUpperCase()))
    } else {
      category = currentGroup
      if (category) {
        adsRequestOptions.group = category.id
        isPageExists = true
        await store.dispatch(fetchPageMetaTags({ group: currentGroup.id }, locale?.toUpperCase()))
      }

      isGroupPage = true
      isCategoryPage = false
    }

    if (isPageExists) {
      const paginationParams = {
        ...store.getState().ads.pagination.params,
        currentPage: Number(page),
        adsType: type,
        countPerPage: limit
      }

      if (isCategoryPage) {
        const brand = isServer ? req.query.brand : query.brand

        if (brand && category.id && !isMobileDevice) {
          await store.dispatch(fetchProducts({brand: Number(brand), category: category.id}))
        } else {
          store.dispatch(setProducts([]))
        }

        const service = isServer ? req.query.service : query.service
        const serviceType = isServer ? req.query.serviceType : query.serviceType
        if (service && category.id && !isMobileDevice) {
          await store.dispatch(fetchServiceTypes({
            service: Number(service),
            serviceType: Number(serviceType),
            category: category.id
          }))
        } else {
          store.dispatch(setServiceTypes([]))
        }
      } else {
        store.dispatch(setCurrentSubCategory(null))
        store.dispatch(setBrands([]))
        store.dispatch(setProducts([]))
        store.dispatch(setEquipment([]))
        store.dispatch(setServices([]))
        store.dispatch(setServiceTypes([]))
      }

      await store.dispatch(fetchAds({ ...adsRequestOptions, locale: locale?.toUpperCase() || 'ME' }, paginationParams))

      filterValues = { ...adsRequestOptions, locale: locale?.toUpperCase() || 'ME' }
    }

    store.dispatch(setIsGroupPage(isGroupPage))
    store.dispatch(setIsCategoryPage(isCategoryPage))

    return {
      title: category && category.title
        ? `${config.pages.category.title} - ${category.title} | ${config.pages.defaultTitle}`
        : isPageExists
          ? `${config.pages.category.title} | ${config.pages.defaultTitle}`
          : config.pages.notFoundTitle,
      categoryTitle: category && category.title ? category.title : '',
      isMobileDevice,
      isPageExists,
      formStyle,
      filterValues,
      state: CategoryPage.getPageState(store, isPageExists)
    }
  }

  static getPageState (store, isPageExists = false) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.profile.priceTypes = currentState.user.profile.priceTypes
      state.user.listSidebar = currentState.user.listSidebar

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = !isPageExists
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.userTypes = currentState.common.userTypes
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.groups = currentState.groups

      state.categories.currentSubcategory = currentState.categories.currentSubcategory
      state.categories.groupCategories = currentState.categories.groupCategories

      if (isPageExists) {
        state.ads.list = currentState.ads.list
        state.ads.pagination = currentState.ads.pagination
        state.ads.brands = currentState.ads.brands
        state.ads.products = currentState.ads.products
        state.ads.equipment = currentState.ads.equipment
        state.ads.services = currentState.ads.services
        state.ads.serviceTypes = currentState.ads.serviceTypes
        state.ads.detail.reportTypes = currentState.ads.detail.reportTypes
        state.ads.detail.registrationFormulas = currentState.ads.detail.registrationFormulas
      }

      state.geoObjects.countries = currentState.geoObjects.countries
      state.geoObjects.regions = currentState.geoObjects.regions
      state.geoObjects.cities = currentState.geoObjects.cities

      state.form = currentState.form
    }
    return state
  }

  render () {
    const { categoryTitle, isPageExists, formStyle, isMobileDevice, i18n, filterValues } = this.props

    const { t } = i18n

    return isPageExists ? (
      <Page>
        {!isMobileDevice ? <AdsHeader filterValues={filterValues} formStyle={formStyle} /> : <GroupsMenuMobile />}
        {isMobileDevice ? <PanelMobile filterValues={filterValues} formStyle={formStyle} /> : null}
        <AdsList
          noAdsMessage={t('common:noAdsMessage')}
          filterValues={filterValues}
          formStyle={formStyle}
          title={`${t('common:category_page_title')} (${categoryTitle})`}
        />
        <CategoryPagination />
        {isMobileDevice ? <BottomNavigation /> : null}
      </Page>
    ) : <Page404 />
  }
}

CategoryPage.propTypes = {
  categoryTitle: PropTypes.string,
  formStyle: PropTypes.string.isRequired,
  filterValues: PropTypes.object.isRequired,
  isPageExists: PropTypes.bool.isRequired
}

CategoryPage.defaultProps = {
  isPageExists: false
}

export default withTranslation(CategoryPage)
